type ColorType = "solid" | "gradient" | "light";
type ColorName =
  | "red"
  | "green"
  | "blue"
  | "orange"
  | "yellow"
  | "purple"
  | "pink"
  | "gray"
  | "black"
  | "white";

const colorMapper: Record<ColorName, Record<ColorType, string>> = {
  red: {
    solid: "bg-red-600 text-white",
    gradient: "bg-gradient-to-r from-red-400 via-red-500 to-red-600 text-white",
    light: "bg-red-50 text-red-700",
  },
  green: {
    solid: "bg-green-600 text-white",
    gradient: "bg-gradient-to-r from-green-400 via-green-500 to-green-600 text-white",
    light: "bg-green-50 text-green-700",
  },
  blue: {
    solid: "bg-blue-600 text-white",
    gradient: "bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600 text-white",
    light: "bg-blue-50 text-blue-700",
  },
  orange: {
    solid: "bg-orange-600 text-white",
    gradient: "bg-gradient-to-r from-orange-400 via-orange-500 to-orange-600 text-white",
    light: "bg-orange-50 text-orange-700",
  },
  yellow: {
    solid: "bg-yellow-500 text-gray-900",
    gradient: "bg-gradient-to-r from-yellow-300 via-yellow-400 to-yellow-500 text-gray-900",
    light: "bg-yellow-50 text-yellow-700",
  },
  purple: {
    solid: "bg-purple-600 text-white",
    gradient: "bg-gradient-to-r from-purple-400 via-purple-500 to-purple-600 text-white",
    light: "bg-purple-50 text-purple-700",
  },
  pink: {
    solid: "bg-pink-600 text-white",
    gradient: "bg-gradient-to-r from-pink-400 via-pink-500 to-pink-600 text-white",
    light: "bg-pink-50 text-pink-700",
  },
  gray: {
    solid: "bg-gray-600 text-white",
    gradient: "bg-gradient-to-r from-gray-400 via-gray-500 to-gray-600 text-white",
    light: "bg-gray-50 text-gray-700",
  },
  black: {
    solid: "bg-black text-white",
    gradient: "bg-gradient-to-r from-gray-700 via-gray-800 to-black text-white",
    light: "bg-gray-100 text-black",
  },
  white: {
    solid: "bg-white text-gray-900 border border-gray-200",
    gradient: "bg-gradient-to-r from-gray-50 via-white to-gray-50 text-gray-900 border border-gray-200",
    light: "bg-gray-50 text-gray-700",
  },
};

export function getAnnouncementStyles(color?: ColorName, colorType: ColorType = "solid") {
  if (!color) return "bg-white text-gray-900 border border-gray-200";
  return colorMapper[color][colorType];
}

export function getIconStyles(color?: ColorName, colorType: ColorType = "solid") {
  if (!color) return "bg-gray-100 text-gray-600";
  
  const iconStyles: Record<ColorType, string> = {
    solid: `bg-${color}-100 text-${color}-600`,
    gradient: `bg-${color}-100 text-${color}-600`,
    light: `bg-${color}-100 text-${color}-600`,
  };
  
  return iconStyles[colorType];
}

export function getBorderColor(color?: ColorName, colorType: ColorType = "solid") {
  if (!color) return "border-gray-200";
  
  // For light variants, use a darker border
  if (colorType === "light") {
    return `border-${color}-200`;
  }
  
  // For dark backgrounds (solid and gradient), use white border
  return "border-white/10";
} 